export enum RequestConfig {
  Vault,
  Unauthed,
  Form,
  Default,
  Agent,
  /**
   * Unauthed JSON config targeting the Addressulator service host (country
   * reference data) instead of API_HOST.
   */
  Addressulator,
  /**
   * CSP-authenticated JSON config (CSP JWT, not the regular user JWT) for
   * customer-support-portal endpoints like /csp/me.
   */
  Csp,
}
